Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-quantity-selector', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-product-details-quantity-selector', $context);

        if ($control.length < 1)
            return;

        $.each($control, function (i, control) {
            var $item = $(control);
            var $field = $item.find('.js-qty-text');
            var step = $item.find('.js-qty-text').attr('data-step');
            if (parseInt(step).toString() === step) {
                step = parseInt(step);
            } else {
                step = 1;
            }

            /* SELECT ELEMENT NOT USED
    
            $item.on('change', '.js-selector', function (e) {
    
                var $this = $(this);
    
                var qty = $this.val();
    
                Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.SetQuantity(qty));
            });
    
            */
            $item.on('keyup', 'input[class="js-qty-text"]', function (e) {
                var quantity = $(this).val();
                if ($(this).closest(".mobile-selector").length) {
                    $('.desktop-selector .x-product-details-quantity-selector .js-qty-text').val(quantity);
                }
                else {
                    $('.mobile-selector .x-product-details-quantity-selector .js-qty-text').val(quantity);
                }
                Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.SetQuantity(quantity))



            });
            $item.on('click', '.js-button-minus', function (event) {

                if ($control.hasClass('disabled'))
                    return;

                var qty = $field.val();
                if (qty === parseInt(qty).toString()) {
                    qty = parseInt(qty);
                    if (qty > step && qty % step === 0) {
                        qty -= step;
                    }
                } else {
                    qty = step;
                }
                $field.val(qty);

                //case for default product details AND
                //for lenses product details with same power in both eyes
                if (sameOnBothEyes) {
                    Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.SetQuantity(qty));
                }
                //case for lenses product details with different power in each eye
                else {
                    if ($(this).closest('.spinner-container').parent('.x-versions').length > 0) {
                        initialState.qty = qty;
                    } else if ($(this).closest('.spinner-container').parent('.x-duplicated-versions').length > 0) {
                        duplicatedState.qty = qty;
                    }
                }
            });

            $item.on('click', '.js-button-plus', function (event) {

                if ($control.hasClass('disabled'))
                    return;

                var qty = $field.val();
                if (qty === parseInt(qty).toString()) {
                    qty = parseInt(qty);
                    qty += step;
                } else {
                    qty = step;
                }
                $field.val(qty);

                //case for default product details AND
                //for lenses product details with same power in both eyes
                if (sameOnBothEyes) {
                    Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.SetQuantity(qty));
                }
                //case for lenses product details with different power in each eye
                else {
                    if ($(this).closest('.spinner-container').parent('.x-versions').length > 0) {
                        initialState.qty = qty;
                    } else if ($(this).closest('.spinner-container').parent('.x-duplicated-versions').length > 0) {
                        duplicatedState.qty = qty;
                    }
                }
            });

        });
    });
});